import { gql } from "@apollo/client"

export interface RequestDemoInput {
  companyName: string
  jobTitle?: string
  email: string
  productType: string
  acceptTc: boolean
}

export const REQUEST_DEMO = gql`
  mutation requestDemo($input: RequestDemoInput!) {
    requestDemo(input: $input) {
      errors {
        field
        messages
      }
    }
  }
`
